(function() {
  function supportsNeededFeatures() {
    try {
      // Proxy is required by Vue 3 reactivity. Do a small Proxy smoke-test.
      if (typeof Proxy === 'undefined') return false;
      try {
        const p = new Proxy({}, { get: () => 1 });
        if (p.x !== 1) return false;
      } catch (e) {
        return false;
      }

      if (typeof Promise === 'undefined') return false;
      if (typeof Map === 'undefined') return false;
      if (typeof Set === 'undefined') return false;
      if (typeof Symbol === 'undefined') return false;
      if (typeof Object.assign !== 'function') return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  if (!supportsNeededFeatures()) {
    var app = document.getElementById('app');
    if (app) {
      app.innerHTML = '\n        <div class="container mt-5">\n          <div class="alert alert-warning" role="alert">\n            <strong>Tu navegador es demasiado antiguo para ejecutar la aplicación.</strong>\n            <p class="mt-2">Actualiza a una versión más moderna de tu navegador o usa Chrome, Firefox, Edge o Safari reciente.</p>\n          </div>\n        </div>\n      ';
    }
    // Do not load the app bundle
    return;
  }

  // Capture global error/rejection events to get better diagnostics (some browsers produce native stacks)
  var __lastGlobalError = null;
  window.addEventListener('error', function(e) {
    try {
      __lastGlobalError = {
        type: 'error',
        message: e && e.message ? String(e.message) : null,
        filename: e && e.filename ? String(e.filename) : null,
        lineno: e && e.lineno ? e.lineno : null,
        colno: e && e.colno ? e.colno : null,
        errorStack: e && e.error && (e.error.stack || e.error.message) ? String(e.error.stack || e.error.message) : null
      };
    } catch (ignore) {
      __lastGlobalError = { type: 'error', message: String(e) };
    }
  });
  window.addEventListener('unhandledrejection', function(e) {
    try {
      var reason = e && e.reason ? e.reason : e;
      __lastGlobalError = {
        type: 'unhandledrejection',
        message: reason && reason.message ? String(reason.message) : String(reason),
        errorStack: reason && (reason.stack || reason.message) ? String(reason.stack || reason.message) : null
      };
    } catch (ignore) {
      __lastGlobalError = { type: 'unhandledrejection', message: String(e) };
    }
  });

  // Environment looks compatible — dynamically import the real app entry
  import('./entry-app.js')
    .catch(function(err) {
      console.error('Error loading app bundle:', err);

      // we check an error query flag. if it's not present, we reload with a query error flag
      if (!window.location.search.includes('error=true')) {
        window.location.search += (window.location.search ? '&' : '?') + 'error=true';
        return;
      }

      var app = document.getElementById('app');
      if (app) {
        // Build a safe, formatted error display using textContent to avoid XSS
        app.innerHTML = '';
        var container = document.createElement('div');
        container.className = 'container mt-5';

        var alert = document.createElement('div');
        alert.className = 'alert alert-danger';
        alert.setAttribute('role', 'alert');

        var strong = document.createElement('strong');
        strong.textContent = 'Error al cargar la aplicación.';
        alert.appendChild(strong);

        var p = document.createElement('p');
        p.className = 'mt-2';
        p.textContent = 'Detalles del error:';
        alert.appendChild(p);

        var pre = document.createElement('pre');
        pre.style.whiteSpace = 'pre-wrap';
        pre.style.maxHeight = '240px';
        pre.style.overflow = 'auto';
        pre.style.background = 'rgba(0,0,0,0.03)';
        pre.style.padding = '8px';
        pre.style.borderRadius = '4px';

        var detail = '';
        try {
          // Prefer an explicit, human-readable assembly: err.name, err.message, err.stack
          if (err && (err.name || err.message)) {
            detail = (err.name ? (err.name + ': ') : '') + (err.message ? err.message : '');
            if (err.stack) {
              detail += '\n' + String(err.stack);
            }
          } else {
            detail = String(err);
          }

          // If a global error was captured, append its info (useful for module load failures reported via window events)
          if (__lastGlobalError) {
            detail += '\n\n--- Evento global capturado ---\n';
            if (__lastGlobalError.type) detail += 'Tipo: ' + __lastGlobalError.type + '\n';
            if (__lastGlobalError.message) detail += 'Mensaje: ' + __lastGlobalError.message + '\n';
            if (__lastGlobalError.filename) detail += 'Archivo: ' + __lastGlobalError.filename + '\n';
            if (__lastGlobalError.lineno != null) detail += 'Línea: ' + __lastGlobalError.lineno + '\n';
            if (__lastGlobalError.colno != null) detail += 'Columna: ' + __lastGlobalError.colno + '\n';
            if (__lastGlobalError.errorStack) detail += 'Traza: ' + __lastGlobalError.errorStack + '\n';
          }
        } catch (e) {
          detail = String(err);
        }
        // Truncate long stacks to keep UI tidy
        if (detail.length > 8000) {
          detail = detail.slice(0, 8000) + '\n...[truncated]';
        }
        pre.textContent = detail;

        alert.appendChild(pre);
        container.appendChild(alert);
        app.appendChild(container);
      }
    });
})();
